/**
 * Environment configuration
 *
 * This file exports all environment variables for use in the application.
 * Variables are automatically mapped from env.schema.ts
 *
 * DO NOT edit this file - add new variables to env.schema.ts instead.
 */

import { ENV_VARS, OPTIONAL_ENV_VARS } from './env.schema';

// NOTE: buildEnv() below already maps OPTIONAL_ENV_VARS; the exported type also
// surfaces them (as optional strings) so consumers can read env.<OPTIONAL_VAR>.

// Automatically build the env object from the schema (required + optional vars)
const buildEnv = () => {
  const result: Record<string, string> = {};

  for (const key of [...Object.keys(ENV_VARS), ...Object.keys(OPTIONAL_ENV_VARS)]) {
    const viteKey = `VITE_${key}` as keyof ImportMetaEnv;
    result[key] = import.meta.env[viteKey];
  }

  return result;
};

export const env = {
  ...buildEnv(),
  // Environment flags (not in schema)
  IS_PROD: import.meta.env.PROD,
  IS_DEV: import.meta.env.DEV,
  // Vite build mode — the 3-way env tier (development / staging / production)
  // that IS_PROD/IS_DEV (booleans, both true for staging AND production) can't
  // express. Set per environment by the `--mode` flag in the build:* scripts.
  MODE: import.meta.env.MODE,
} as {
  [K in keyof typeof ENV_VARS]: string;
} & {
  // Optional vars are present at runtime (buildEnv iterates them) but may be
  // unset, so they are typed as optional strings.
  [K in keyof typeof OPTIONAL_ENV_VARS]?: string;
} & {
  IS_PROD: boolean;
  IS_DEV: boolean;
  MODE: string;
};
